import createReactComponent from '../createReactComponent';
export default createReactComponent('grip-vertical', 'GripVertical', [["path",{"d":"M9.667 12H9m6 0h-.667M9.667 7H9m6 0h-.667M9.667 17H9m6 0h-.667","key":"svg-0"}]]);